import { useContext } from 'react';
import { PinwheelContext } from 'shared/providers/pinwheel/PinwheelContextProvider/PinwheelContextProvider';

const usePinwheel = () => {
  const context = useContext(PinwheelContext);
  if (!context) {
    throw new Error('usePinwheel must be used inside provider');
  }
  return context;
};

export default usePinwheel;
